module.exports = __webpack_public_path__ + "media/icons/document-search-cc1204b4.svg";